{
  "title": "Ajouter le membre du ménage",
  "client": "Client",
  "relationship": "Relation",
  "relationshipTo": "Relation avec {{whom}} (membre principal)",
  "alreadyMemberOf": "Le client est déjà membre de",
  "thisHousehold": "ce ménage",
  "anotherHousehold": "un autre ménage",
  "memberSummary": "Résumé sur le membre",
  "pleaseReview": "Veuillez passer en revue vos renseignements afin de vérifier leur exactitude.",
  "name": "Nom",
  "dateOfBirth": "Date de naissance",
  "continue": "Continuer",
  "added": "{{memberName}} a été ajouté à ce ménage",
  "failed": "Échec de l'ajout d'un nouveau membre.",
  "done": "Terminé",
  "createNewClient": "Créer un nouveau client",
  "accessType": "Autorisations",
  "establishedDate": "Date d'établissement"
}
